import {RoleBasedPermission} from '@hconnect/apiclient'
import {Routes, Route, Navigate} from 'react-router'

import {PermissionsValidationWrapper} from '../common/providers'
import {RefraFlexibleReport} from '../refra-flexible-report'
import {RefraPlanning} from '../refra-planning'
import {RefraStaticParts} from '../refra-static-parts'
import {StaticPartDetail} from '../refra-static-parts/components/StaticPartDetail'
import {
  StaticPartReplacementEdit,
  StaticPartReplacementEditNotFound,
  StaticPartReplacementEditDetail
} from '../refra-static-parts/components/StaticPartReplacementEdit'
import {StaticPartsOverview} from '../refra-static-parts/components/StaticPartsOverview'

import {ROUTES} from './routes'

interface AppRoutesProps {
  // Catalog is injected by the host app (app → feature) instead of imported here.
  catalogElement: React.ReactElement
}

export const AppRoutes: React.FC<AppRoutesProps> = ({catalogElement}) => {
  return (
    <Routes>
      <Route
        path={ROUTES.REFRA_CATALOG.path}
        element={
          <PermissionsValidationWrapper
            requiredPermissionTypes={Object.values(RoleBasedPermission)}
            operator="OR"
          >
            {catalogElement}
          </PermissionsValidationWrapper>
        }
      />
      <Route
        path={ROUTES.REFRA_PLANNING.path}
        element={
          <PermissionsValidationWrapper
            requiredPermissionTypes={Object.values(RoleBasedPermission)}
            operator="OR"
          >
            <RefraPlanning />
          </PermissionsValidationWrapper>
        }
      />
      <Route
        path={ROUTES.STATIC_PARTS.path}
        element={
          <PermissionsValidationWrapper
            requiredPermissionTypes={Object.values(RoleBasedPermission)}
            operator="OR"
          >
            <RefraStaticParts />
          </PermissionsValidationWrapper>
        }
      >
        <Route path={ROUTES.STATIC_PARTS.EDIT.path} element={<StaticPartReplacementEdit />}>
          <Route
            path={ROUTES.STATIC_PARTS.EDIT.COMPONENT_EDIT.path}
            element={<StaticPartReplacementEditDetail />}
          />
          <Route index element={<StaticPartReplacementEditNotFound />} />
        </Route>
        <Route path={ROUTES.STATIC_PARTS.DETAIL.path} element={<StaticPartDetail />} />
        <Route path={ROUTES.STATIC_PARTS.OVERVIEW.path} element={<StaticPartsOverview />} />
      </Route>
      <Route
        path={ROUTES.FLEXIBLE_REPORT.path}
        element={
          <PermissionsValidationWrapper
            requiredPermissionTypes={Object.values(RoleBasedPermission)}
            operator="OR"
          >
            <RefraFlexibleReport />
          </PermissionsValidationWrapper>
        }
      />
      <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND.path} replace />} />
    </Routes>
  )
}
